// src/pages/MedicalCaseDiscussions/components/CaseFeed.jsx
import React from "react";
import CaseCard from "../Casecard/Casecard";
import "./Casefeed.css";

export default function CaseFeed({
  cases = [],
  onCaseClick,
  isSaved,
  onToggleSave,
  pendingKey,
  onEditCase,
  onDeleteCase,
  onDeleteLive,
}) {
  if (!cases.length) {
    return <div className="mcd-feed__empty">No discussions to show.</div>;
  }

  return (
    <div className="mcd-feed">
      {cases.map((caseItem) => (
        <CaseCard
          key={caseItem.id}
          caseItem={caseItem}
          onClick={onCaseClick}
          isSaved={isSaved?.("medical_case", caseItem.id || caseItem.raw?.id || caseItem.raw?._id)}
          onToggleSave={onToggleSave}
          isSaving={pendingKey === `medical_case:${String(caseItem.id || caseItem.raw?.id || caseItem.raw?._id)}`}
          canManage={caseItem.canManage}
          canManageLive={caseItem.canManageLive}
          onEditCase={onEditCase}
          onDeleteCase={onDeleteCase}
          onDeleteLive={onDeleteLive}
        />
      ))}
    </div>
  );
}